import client from './client';

// 메인화면 역할별 구성 1단계 (2026-10-23).
export const getHomeLayout = () => client.get('/api/v1/home/layout');

export const getWidgetSummary = (code) => client.get(`/api/v1/home/widgets/${code}`);
